import { createApp, h } from 'vue';
import router from './router';
import store from './store';
import App from './App.vue';
import PrimeVue from 'primevue/config';
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Avatar from 'primevue/avatar';
import AvatarGroup from 'primevue/avatargroup';
import Badge from 'primevue/badge';
import BadgeDirective from 'primevue/badgedirective';
import Button from 'primevue/button';
import Breadcrumb from 'primevue/breadcrumb';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Carousel from 'primevue/carousel';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chip from 'primevue/chip';
import Chips from 'primevue/chips';
import ColorPicker from 'primevue/colorpicker';
import Column from 'primevue/column';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmationService from 'primevue/confirmationservice';
import ContextMenu from 'primevue/contextmenu';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
import Dropdown from 'primevue/dropdown';
import Dock from 'primevue/dock';
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import FullCalendar from 'primevue/fullcalendar';
import Galleria from 'primevue/galleria';
import Image from 'primevue/image';
import InlineMessage from 'primevue/inlinemessage';
import Inplace from 'primevue/inplace';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import Knob from 'primevue/knob';
import Listbox from 'primevue/listbox';
import MegaMenu from 'primevue/megamenu';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import OrderList from 'primevue/orderlist';
import OrganizationChart from 'primevue/organizationchart';
import OverlayPanel from 'primevue/overlaypanel';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import ProgressBar from 'primevue/progressbar';
import ProgressSpinner from 'primevue/progressspinner';
import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import Ripple from 'primevue/ripple';
import SelectButton from 'primevue/selectbutton';
import ScrollPanel from 'primevue/scrollpanel';
import ScrollTop from 'primevue/scrolltop';
import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import Skeleton from 'primevue/skeleton';
import SpeedDial from 'primevue/speeddial';
import SplitButton from 'primevue/splitbutton';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import Steps from 'primevue/steps';
import TabMenu from 'primevue/tabmenu';
import Tag from 'primevue/tag';
import TieredMenu from 'primevue/tieredmenu';
import Textarea from 'primevue/textarea';
import Timeline from 'primevue/timeline';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tooltip from 'primevue/tooltip';
import ToggleButton from 'primevue/togglebutton';
import Tree from 'primevue/tree';
import TreeSelect from 'primevue/treeselect';
import TreeTable from 'primevue/treetable';
import TriStateCheckbox from 'primevue/tristatecheckbox';

import CodeHighlight from './AppCodeHighlight';

import ShoppingcartPlugin from './plugins/ShoppingCart';
import PageRouterPlugin from './plugins/PageRouter';
import CacheUtilPlugin from './plugins/CacheUtil';
import DateTimeUtilPlugin from './plugins/DateTimeUtil';
import SystemUtilPlugin from './plugins/SystemUtil';
import AuthUtilPlugin from './plugins/AuthUtil';
import ExternalContentLoaderUtilPlugin from './plugins/ExternalContentLoaderUtil';
import MessageBundlePlugin from "./plugins/MessageBundle";

import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'prismjs/themes/prism-coy.css';
import './App.scss';

//import Access from './pages/Access';
import Error from './pages/Error';
import Login from './pages/Login';
import LoginWithPhone from './pages/LoginWithPhone.vue';
import SignUp from './pages/SignUp';
import RequestResetPassword from './pages/RequestResetPassword.vue';
import RequestResetPasswordByEmail from './pages/RequestResetPasswordByEmail.vue';
import RequestResetPasswordByPhone from './pages/RequestResetPasswordByPhone.vue';
import ResetPasswordWithEmail from './pages/ResetPasswordWithEmail.vue';
import ResetPasswordWithPhone from './pages/ResetPasswordWithPhone.vue';

//import Help from './pages/Help';
//import Login from './pages/Login';
//import NotFound from './pages/NotFound';

//import axios from 'axios';

//Preserve the code that add access token into header of every request if access token is avaialbe in session store.
/*
axios.interceptors.request.use(
    config => {
        let accessToken=sessionStorage.getItem('access_token');
        if(accessToken){
            config.headers['Authorization'] = `Bearer `+accessToken;
        }else{
            config.headers={};
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
*/
/*
axios.interceptors.response.use(
	response => response,
	error => {
		const status = error.response ? error.response.status : null;	  
		if (status === 401) {
			// Handle unauthorized access
			console.log("Error 401");
		} else if (status === 404) {
			// Handle not found errors
		} else {
			// Handle other errors
		}
		return Promise.reject(error);
	}
);
*/

const app = createApp({
    computed: {
        ViewComponent() {
            switch (this.$route.path) {
                case '/error':
                    return Error;
                case '/info':
                    return Error;
                case '/login':
                    return Login;
                case '/login-with-phone':
                    return LoginWithPhone;    
                case '/account-registry':
                    return SignUp;
                case '/reset-password':
                    return RequestResetPassword;  
                case '/request-reset-password-with-email':
                    return RequestResetPasswordByEmail;  
                case '/request-reset-password-with-phone':
                    return RequestResetPasswordByPhone;        
                case '/reset-password-with-email':
                    return ResetPasswordWithEmail;  
                case '/reset-password-with-phone':
                    return ResetPasswordWithPhone;     
                /*	
				case '/notfound':
					return NotFound;
				*/
                default:
                    return App;
            }
        },
    },
    render() {
        return h(this.ViewComponent);
    },
});

app.use(PrimeVue, { ripple: true });
app.use(ShoppingcartPlugin);
app.use(PageRouterPlugin);
app.use(CacheUtilPlugin);
app.use(DateTimeUtilPlugin);
app.use(SystemUtilPlugin);
app.use(AuthUtilPlugin);
app.use(ExternalContentLoaderUtilPlugin);
app.use(MessageBundlePlugin);
app.use(ConfirmationService);
app.use(ToastService);

app.directive('tooltip', Tooltip);
app.directive('ripple', Ripple);
app.directive('code', CodeHighlight);
app.directive('badge', BadgeDirective);

app.component('Accordion', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('AutoComplete', AutoComplete);
app.component('Avatar', Avatar);
app.component('AvatarGroup', AvatarGroup);
app.component('Badge', Badge);
app.component('Breadcrumb', Breadcrumb);
app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Card', Card);
app.component('Dock', Dock);
app.component('Carousel', Carousel);
app.component('Chart', Chart);
app.component('Checkbox', Checkbox);
app.component('Chip', Chip);
app.component('Chips', Chips);
app.component('ColorPicker', ColorPicker);
app.component('Column', Column);
app.component('ConfirmDialog', ConfirmDialog);
app.component('ConfirmPopup', ConfirmPopup);
app.component('ContextMenu', ContextMenu);
app.component('DataTable', DataTable);
app.component('DataView', DataView);
app.component('DataViewLayoutOptions', DataViewLayoutOptions);
app.component('Dialog', Dialog);
app.component('Divider', Divider);
app.component('Dropdown', Dropdown);
app.component('Fieldset', Fieldset);
app.component('FileUpload', FileUpload);
app.component('FullCalendar', FullCalendar);
app.component('Galleria', Galleria);
app.component('Image', Image);
app.component('InlineMessage', InlineMessage);
app.component('Inplace', Inplace);
app.component('InputMask', InputMask);
app.component('InputNumber', InputNumber);
app.component('InputSwitch', InputSwitch);
app.component('InputText', InputText);
app.component('Knob', Knob);
app.component('Listbox', Listbox);
app.component('MegaMenu', MegaMenu);
app.component('Menu', Menu);
app.component('Menubar', Menubar);
app.component('Message', Message);
app.component('MultiSelect', MultiSelect);
app.component('OrderList', OrderList);
app.component('OrganizationChart', OrganizationChart);
app.component('OverlayPanel', OverlayPanel);
app.component('Paginator', Paginator);
app.component('Panel', Panel);
app.component('PanelMenu', PanelMenu);
app.component('Password', Password);
app.component('PickList', PickList);
app.component('ProgressBar', ProgressBar);
app.component('ProgressSpinner', ProgressSpinner);
app.component('RadioButton', RadioButton);
app.component('Rating', Rating);
app.component('SelectButton', SelectButton);
app.component('ScrollPanel', ScrollPanel);
app.component('ScrollTop', ScrollTop);
app.component('Slider', Slider);
app.component('Sidebar', Sidebar);
app.component('Skeleton', Skeleton);
app.component('SpeedDial', SpeedDial);
app.component('SplitButton', SplitButton);
app.component('Splitter', Splitter);
app.component('SplitterPanel', SplitterPanel);
app.component('Steps', Steps);
app.component('TabMenu', TabMenu);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Tag', Tag);
app.component('Textarea', Textarea);
app.component('TieredMenu', TieredMenu);
app.component('Timeline', Timeline);
app.component('Toast', Toast);
app.component('Toolbar', Toolbar);
app.component('ToggleButton', ToggleButton);
app.component('Tree', Tree);
app.component('TreeSelect', TreeSelect);
app.component('TreeTable', TreeTable);
app.component('TriStateCheckbox', TriStateCheckbox);

app.use(store);
router.beforeEach((to, from, next) => {
    //console.log("from:",from.fullPath);
    console.log("to:",to);

    /*
    //if language selection is required based on path, define the logic here.
    if(to&&to.path){
        let currentPath=to.path;
        if(currentPath==='/cart'||currentPath==='/order-init'){            
            store.dispatch('createLanguageSelectionFlag', true);
        }else{
            store.dispatch('removeLanguageSelectionFlag');
        }
    }*/
    
    let params = to.params;
    if (params && params.supplierRefId) {
        let incomingSupplierRefId = params.supplierRefId;
        let currentSupplierRefId = store.state.subjectId;
        let newStoreFlag = currentSupplierRefId && incomingSupplierRefId !== currentSupplierRefId;
        if (newStoreFlag) {
            let cart = store.state.cart;
            //console.log("Cart:",cart);
            if (cart && cart.totalItems > 0) {
                next({ path: '/change-store/' + currentSupplierRefId + '/' + incomingSupplierRefId });
            } else {
                next();
            }
            //console.log("Changing store..");
            //console.log("currentSupplierRefId:"+store.state.subjectId);
        } else {
            next();
        }
    } else {
        next();
    }
});
app.use(router);

app.mount('#app');
